/*
 * @Author: Ygm
 * @Date: 2024-04-18 17:37:56
 * @LastEditors: Ygm
 * @LastEditTime: 2024-08-12 15:19:08
 * @Description: 发送postMessage
 */
/**
 * @description 通知刷新
 */
const noticeFatherRefresh = () => {
  const params = {
    name: '刷新',
    type: 'refresh_req'
  }
  // BroadCast Channel 跨标签通信
  const channel = new BroadcastChannel('refreshChannel')
  channel.postMessage(params)

  if (window.opener) {
    window.opener.postMessage(params, window.location.ancestorOrigins[0])
  }
  if (window.parent) {
    window.parent.postMessage(params, window.location.ancestorOrigins[0])
  }
}

/**
 * @description 通知父窗口打开IM
 * @param {object} data
 */
const noticeFatherOpenIM = (data = {}) => {
  const params = {
    name: '打开即时通讯',
    type: 'open_im',
    data
  }

  if (window.opener) {
    window.opener.postMessage(params, window.location.ancestorOrigins[0])
  }
  if (window.parent) {
    window.parent.postMessage(params, window.location.ancestorOrigins[0])
  }
}

/**
 * @description 通知父窗口
 * @param {object} data
 */
const noticeFather = (data = {}) => {
  if (window.opener) {
    window.opener.postMessage(data, window.location.ancestorOrigins[0])
  }
  if (window.parent) {
    window.parent.postMessage(data, window.location.ancestorOrigins[0])
  }
}

export { noticeFatherRefresh, noticeFatherOpenIM, noticeFather }



// WEBPACK FOOTER //
// ./src/utils/postMessage.js